__turbopack_context__.v({
  "currentValue": "DoubleRangeSlider-module__iFM2kW__currentValue",
  "currentValues": "DoubleRangeSlider-module__iFM2kW__currentValues",
  "dot": "DoubleRangeSlider-module__iFM2kW__dot",
  "rangeInput": "DoubleRangeSlider-module__iFM2kW__rangeInput",
  "rangeLabel": "DoubleRangeSlider-module__iFM2kW__rangeLabel",
  "rangeSelected": "DoubleRangeSlider-module__iFM2kW__rangeSelected",
  "rangeSlider": "DoubleRangeSlider-module__iFM2kW__rangeSlider",
  "sliderContainer": "DoubleRangeSlider-module__iFM2kW__sliderContainer",
  "sliderLabel": "DoubleRangeSlider-module__iFM2kW__sliderLabel",
});
